/** CSS class names driving roster action-icon color (see compliance-items.scss `.evidence` states). */
export enum IconFulfillmentState {
    NOT_FULFILLED = 'state-not-fulfilled',
    FULFILLED = 'state-fulfilled'
}
